module.exports = __webpack_public_path__ + "static/BookFrontSmall-68249a5e605384c3a8b2ea6601a40cae.jpg";